export enum SearchModifier {
  Prioritize = 'Prioritize',
  Families = 'Families',
  Groups = 'Groups',
}
